import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { TESTIMONIALS } from '@/constants/testIds';

const REVIEWS = [
	{
		quote:
			'Blew a tire outside of Denver at 2 a.m. with two sleeping kids in the car. They picked up on the first ring and had a truck to me in 34 minutes. Absolute lifesavers.',
		name: 'Marcus H.',
		place: 'Denver, CO',
		service: 'Flat Tire',
	},
	{
		quote:
			'Locked my keys in the truck at a gas station in the middle of nowhere. Zero panic — one call and the operator was courteous, fast, and didn’t damage a thing.',
		name: 'Elena R.',
		place: 'Amarillo, TX',
		service: 'Lockout',
	},
	{
		quote:
			'Ran out of diesel on I-90. Dispatcher gave me an accurate ETA and it was actually early. Priced fairly, no surprise fees. This is how a service company should run.',
		name: 'David P.',
		place: 'Bozeman, MT',
		service: 'Fuel Delivery',
	},
	{
		quote:
			'Slid off an icy back road into a ditch. They winched me out, checked the alignment, and sent me on my way. Utterly professional.',
		name: 'Grace L.',
		place: 'Portland, ME',
		service: 'Winch-Out',
	},
];

export const Testimonials = () => {
	return (
		<section
			data-testid={TESTIMONIALS.root}
			className="bg-white"
		>
			<div className="mx-auto max-w-[1400px] px-4 sm:px-8 py-24 sm:py-32">
				<div className="grid md:grid-cols-12 gap-8 mb-14 sm:mb-20">
					<div className="md:col-span-4">
						<div className="font-chivo text-xs uppercase tracking-[0.3em] text-brand-red font-bold mb-4">
							/ Field Reports
						</div>
					</div>
					<div className="md:col-span-8">
						<motion.h2
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.7 }}
							className="font-anton text-[40px] sm:text-[68px] md:text-[88px] leading-[0.92] text-brand-navy"
						>
							Real calls.{' '}
							<span className="text-brand-red">Real outcomes.</span>
						</motion.h2>
					</div>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-brand-navy">
					{REVIEWS.map((r, i) => (
						<motion.blockquote
							key={i}
							data-testid={TESTIMONIALS.item(i)}
							initial={{ opacity: 0, y: 24 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true, margin: '-80px' }}
							transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
							className="relative border-r border-b border-brand-navy p-8 sm:p-12 bg-white flex flex-col"
						>
							<div className="flex items-center gap-1 mb-6">
								{[0, 1, 2, 3, 4].map((s) => (
									<Star
										key={s}
										className="w-4 h-4 text-brand-red"
										fill="#D32F2F"
										strokeWidth={0}
									/>
								))}
								<span className="ml-3 font-chivo text-[11px] uppercase tracking-[0.28em] font-bold text-brand-navy/60">
									{r.service}
								</span>
							</div>

							<p className="font-anton text-2xl sm:text-3xl md:text-[34px] leading-tight text-brand-navy">
								“{r.quote}”
							</p>

							<div className="mt-8 pt-6 border-t border-brand-navy/15 flex items-center justify-between">
								<div>
									<div className="font-chivo font-black text-brand-navy uppercase tracking-tight text-sm">
										{r.name}
									</div>
									<div className="font-plex text-xs text-brand-navy/60 mt-1">
										{r.place}
									</div>
								</div>
								<div className="font-anton text-3xl text-brand-red/60">
									0{i + 1}
								</div>
							</div>
						</motion.blockquote>
					))}
				</div>
			</div>
		</section>
	);
};

export default Testimonials;
